import { EventShirtDetailsProps } from './types'

export const MOTTO = 'Empowering Your Moments, Mastering Your Time.'
export const FILE_SIZE = 2 * 1024 * 1024
export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/gif',
  'image/png',
]

export const TSHIRT = 'TSHIRT'
export const MEDAL = 'MEDAL'
export const EBADGE = 'EBADGE'
export const EBIB = 'EBIB'
export const ECERT = 'ECERT'
export const HANDTOWEL = 'HANDTOWEL'
export const BAG = 'BAG'
export const MASK = 'MASK'

export const AWARDS = {
  TSHIRT: 'T-shirt',
  MEDAL: 'Medal',
  EBADGE: 'eBadge',
  EBIB: 'eBib',
  ECERT: 'eCertificate',
  HANDTOWEL: 'Hand towel',
  BAG: 'Bag',
  MASK: 'Mask',
}

export const COMING_SOON = 1
export const NOT_COMING_SOON = 0

export const TSHIRT_SIZES = {
  // K16: '16',
  // K18: '18',
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
  _2XL: '2XL',
  _3XL: '3XL',
  // _4XL: '4XL',
}

export const ALL_TSHIRT_SIZES = {
  ...TSHIRT_SIZES,
  K16: '16',
  K18: '18',
  K4: '4',
  K6: '6',
  K8: '8',
  K10: '10',
  K12: '12',
  K14: '14',
  K20: '20',
  _2XS: '2XS',
  _4XL: '4XL',
}

export const FAMILY_TSHIRT_SIZES = {
  '#4': '#4',
  '#6': '#6',
  '#8': '#8',
  '#10': '#10',
  '#12': '#12',
  '#14': '#14',
  '#16': '#16',
  '#18': '#18',
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
  '2XL': '2XL',
  '3XL': '3XL',
  // '4XL': '4XL',
}

export const DEFAULT_SIZE_CHART = 'mw_shirt_v1.jpg'
export const DEFAULT_JERSEY_CHART = 'jersey_size_chart_v2.jpg'
export const DEFAULT_KIDS_SIZE_CHART = 'kids_size_chart_v2.jpeg'
export const JERSEY_SHIRT_SIZES = {
  _3XS: '3XS',
  _2XS: '2XS',
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
  _2XL: '2XL',
  _3XL: '3XL',
}

export const EVENT_SHIRT_LABEL = 'Event Shirt Type'
export const EVENT_SHIRT_OPTIONS = ['T-SHIRT', 'SANDO']
export const SHIRT_KEY = {
  SHIRT1: 'SHIRT1',
  SHIRT2: 'SHIRT2',
}

export const EVENT_SHIRT_DETAILS: EventShirtDetailsProps = {
  SHIRT1: {
    LABEL: 'Shirt',
  },
}

export const GENDERS = {
  FEMALE: 'Female',
  MALE: 'Male',
}

export const SHIPPING_PREFERENCES = {
  CLAIM: 'Claim on site',
  COD: 'Cash On Delivery (COD)',
}

export const PAYMENT_MODES = {
  // PAYPAL: 'PAYPAL',
  CARD: { key: 'CARD', name: 'Credit/Debit Card', image: 'paymongo_card.png' },
  GCASH: { key: 'GCASH', name: 'GCash', image: 'paymongo_gcash.png' },
  GRAB_PAY: {
    key: 'GRAB_PAY',
    name: 'GrabPay',
    image: 'paymongo_grab_pay.png',
  },
  PAYMAYA: { key: 'PAYMAYA', name: 'Maya', image: 'paymongo_maya.png' },
}

export const REFUND_PAYMENT_MODES = {
  BANK: { key: 'BANK', name: 'Bank Deposit', image: 'paymongo_card.png' },
  GCASH: { key: 'GCASH', name: 'GCash', image: 'paymongo_gcash.png' },
}

export const ONSITE_PAYMENT_MODES = {
  CASH: 'Cash',
  ATD: 'ATD',
}

export const CIVIL_STATUSES = {
  SINGLE: 'Single',
  MARRIED: 'Married',
}

export const TEAM_TYPES = {
  DOUBLES: 'DOUBLES',
  DUATHLON: 'DUATHLON',
  TRIATHLON: 'TRIATHLON',
}

export const ACCESS_TYPES = {
  PUBLIC: 'PUBLIC',
  APP: 'APP',
  ONSITE: 'ONSITE',
}

export const EVENT_LOG_ACTION_TYPES = {
  UPDATE: 'UPDATE',
  MANUAL_ADD: 'MANUAL_ADD',
}

export const COUNTRIES = {
  AF: 'Afghanistan',
  AX: 'Aland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua And Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnia And Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, Democratic Republic',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Cote D'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island & Mcdonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic Of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle Of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KR: 'Korea',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyan Arab Jamahiriya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States Of',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  AN: 'Netherlands Antilles',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinian Territory, Occupied',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthelemy',
  SH: 'Saint Helena',
  KN: 'Saint Kitts And Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  PM: 'Saint Pierre And Miquelon',
  VC: 'Saint Vincent And Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome And Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia And Sandwich Isl.',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard And Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad And Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks And Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UM: 'United States Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Viet Nam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis And Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
}

export const DEFAULT_PARTICIPANT_COUNT = 10

export const PARTICIPANT_STATUS = {
  DELETED_REFUND: 'deleted.refund',
  DELETED_DEFER: 'deleted.defer',
} as const

export const PARTICIPANT_DELETE_REASONS = [
  { value: 'refund', label: 'Refund' },
  { value: 'defer', label: 'Defer' },
] as const
